<template>
  <div class="lbv-update-parameters animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card v-if="$store.getters.roleID === '4'">
          <h1 class="lbv-page-title updateParameters">
            Matlab Parameters Dictionary
          </h1>
          <div class="updateParametersInputs">
            <div
              class="section"
              style="margin-top:20px; min-height:100px"
            >
              <b-row class="header">
                <b-col
                  cols="12"
                  style="text-align: center; margin-top:10px"
                >
                  <h3 class="form-label">
                    Description
                  </h3>
                </b-col>
              </b-row>

              <p>This page is provided so that you can create and update definitions of parameters that are going to added to device for leak calculation. </p>
              <p>
                - Click on any parameter from table below to edit parameter
                <br>- Use filter to find your parameter (start typing in the field)
                <br>- Order parameters by clicking "Parameter Name" header
                <br>- When array type of parameter chosen just pass parameters separated by comma e.g. 2, 3.5, 21 (no need to add brackets e.g. [2, 3.5, 21])
              </p>
            </div>

            <form @submit.prevent="updateParam">
              <div
                class="section"
                style="margin-top:20px; min-height:100px"
              >
                <b-row class="header">
                  <b-col
                    cols="12"
                    style="text-align: center; margin-top:10px"
                  >
                    <h3 class="form-label">
                      Description
                    </h3>
                  </b-col>
                </b-row>
                
                <b-row class="push-down">
                  <b-col cols="2">
                    <label class="form-label">Parameter Name:</label>
                  </b-col>
                  <b-col cols="6">
                    <input
                      v-model="parameterName"
                      type="text"
                      class="form-control"
                      @input="parameterNameChange"
                    >
                  </b-col>

                  <b-col cols="2">
                    <label>Parameter type</label>
                  </b-col>
                  <b-col cols="2">
                    <b-form-select
                      v-model="parameterType"
                      class="full-width"
                      @input="changeParameterType"
                    >
                      <option value="number">
                        Number
                      </option>
                      <option value="array">
                        Array
                      </option>
                    </b-form-select>
                  </b-col>
                </b-row>

                <b-row class="push-down">
                  <b-col cols="2">
                    <label>{{ minValLabel }}</label>
                  </b-col>
                  <b-col cols="2">
                    <input
                      id="minValue"
                      v-model="parameterMinValue"
                      type="text"
                      class="form-control full-width"
                      @input="clearError"
                    >
                  </b-col>

                  <b-col cols="2">
                    <label>{{ maxValLabel }}</label>
                  </b-col>
                  <b-col cols="2">
                    <input
                      v-model="parameterMaxValue"
                      type="text"
                      class="form-control full-width"
                      @input="clearError"
                    >
                  </b-col>

                  <b-col cols="2">
                    <label>{{ defValLabel }}</label>
                  </b-col>
                  <b-col cols="2">
                    <input
                      v-model="parameterDefaultValue"
                      type="text"
                      class="form-control full-width"
                      @input="clearError"
                    >
                  </b-col>
                </b-row>

                <b-row class="push-down">
                  <b-col cols="8">
                    <button
                      type="submit"
                      class="btn btn-primary parameterUpdate"
                    >
                      <span>{{ buttonLabel }}</span>
                    </button>
                  </b-col>

                  <b-col cols="2">
                    <label>Filter by parameter name:</label>
                  </b-col>
                  <b-col cols="2">
                    <input
                      v-model="filterParameterName"
                      type="text"
                      class="form-control full-width"
                      @input="filterName"
                    >
                  </b-col>
                </b-row>
              </div>

              <!--b-row class="push-down">
                <b-alert :show="errorMessage != ''" variant="danger">{{errorMessage}}</b-alert>
              </b-row-->

              <div
                class="section"
                style="margin-top:20px;"
              >
                <b-row class="header">
                  <b-col
                    cols="12"
                    style="text-align: center; margin-top:10px"
                  >
                    <h3 class="form-label">
                      List of parameters
                    </h3>
                  </b-col>
                </b-row>

                <b-table
                  responsive
                  striped
                  hover
                  :items="parameterList"
                  :fields="fields"
                  @row-clicked="myRowClickHandler"
                />
              </div>
            </form>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import matlabParameterListMixin from '../mixins/matlabParameterListMixin'

export default {
  name: 'ParameterList',
  mixins: [matlabParameterListMixin]
}
</script>

<style media="screen">


  .lbv-update-parameters .updateParametersInputs label {
    font-size: 0.8rem;
    float: left;
    margin-right: 4px;
    margin-top: 9px;
    font-weight: bold;
  }

  .updateParametersInputs .push-down {
    margin-top: 1rem;
  }

    .updateParametersInputs .section {
    background-color: #F0F0F0;
    border-radius: 15px;
    padding: 7px 15px 15px 15px;
    box-shadow:5px 5px grey;
    min-height:400px
  }

  .updateParametersInputs .section .header{
    background-color: #E0E0E0;
    margin-top: -7px;
    border-radius: 15px 15px 0px 0px;
    height: 50px
  }

  .updateParametersInputs .form-control {
    width: 100%;
    border-radius: 8px
  }

  .updateParametersInputs .form-label {
    align-self: right;
  }

  .parameterUpdate {
    float: left;
    border-radius: 8px;
    width: 200px;
  }

</style>
